<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { regexPatterns } from "../../utils/utils";

export default {
  name: "contactAgentDialog",
  data() {
    return {
      loading: false,
      form: {
        name: "",
        email: "",
        phoneNumber: "",
        message: "",
        actions: []
      },
      rules: {
        name: {
          required: true,
          message: "Please enter your name",
          trigger: "blur"
        },
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: regexPatterns.email
        },
        phoneNumber: {
          required: true,
          message: "Please enter a correct phone number",
          trigger: "blur",
          pattern: regexPatterns.phoneNumber
        }
      }
    };
  },
  props: {
    contactDialogVisible: Boolean,
    propertyId: String
  },
  computed: {
    dialogVisible: {
      get() {
        return this.contactDialogVisible;
      },
      set(value) {
        this.$emit('update:contactDialogVisible', value);
      }
    }
  },
  methods: {
    ...mapActions("contact", ["contact"]),
    handleClose() {
      this.dialogVisible = false;
    },
    onDialogClose() {
      this.form = {
        name: "",
        email: "",
        phoneNumber: "",
        message: "",
        actions: []
      };
      this.$refs.form.clearValidate();
    },
    onSubmit(formName) {
      var that = this;
      if (that.loading) return;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.loading) return;
          that.loading = true;
          that.contact({
            params: {
              id: that.propertyId,
              data: {
                email: that.form.email,
                message: that.form.message,
                name: that.form.name,
                phone: that.form.phoneNumber,
                actions: that.form.actions
              }
            },
            callback: that.callback
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    callback(res) {
      var that = this;
      that.loading = false;
      if (res.data.code == 0) {
        that.$box.alert("", "Successfully submitted", "success");
        that.handleClose();
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    contactOptionChange(val) {
      console.log(val);
      this.form.actions = val;
    }
  }
};
</script>

<template>
  <el-dialog
      :show-close="false"
      :visible.sync="contactDialogVisible"
      @close="onDialogClose"
      :before-close="handleClose"
      center
      custom-class="contact-dialog"
      title=""
      width="100%"
      fullscreen
  >
    <template #title>
      <div class="contact-title">
        Contact agent
        <div class="icon" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </template>
    <div>
      <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="top"
          label-width="100px"
          @submit.native.prevent
          style="font-family: DINosaur-a, sans-serif;"

      >
        <el-form-item label="Name" prop="name">
          <el-input
              v-model="form.name"
              maxlength="50"
              placeholder="Your name"
          ></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input
              v-model="form.email"
              maxlength="100"
              placeholder="Your email"
          ></el-input>
        </el-form-item>
        <el-form-item label="Phone number" prop="phoneNumber">
          <el-input
              v-model="form.phoneNumber"
              maxlength="20"
              placeholder="Your phone number"
          ></el-input>
        </el-form-item>
        <el-form-item class="option-item-group" >
          <el-checkbox-group v-model="form.actions" @change="contactOptionChange">
            <el-checkbox label="MAKE_APPOINTMENT" key="MAKE_APPOINTMENT">Make an appointment</el-checkbox>
            <el-checkbox label="CALL_BACK" key="CALL_BACK">Request a call back</el-checkbox>
            <el-checkbox label="SEND_EMAIL" key="SEND_EMAIL">Send me an email</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="Message" prop="message">
          <el-input
              type="textarea"
              v-model="form.message"
              maxlength="1000"
              placeholder="Message"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align:center">
          <el-button class="submit-button" @click="onSubmit('form')"
          >Confirm
            <i v-if="loading" class="el-icon-loading"></i>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<style scoped>

.contact-title {
  color: #003333;
  text-align: left;
  font-size: 22px;
  font-family: DINosaur-a, sans-serif;
  font-weight: 600;
  margin-bottom: 10px;
}

.contact-title .icon {
  float: right;
  width: 35px;
  height: 35px;
  font-size: 35px;
  cursor: pointer;
  color: #aaaaaa;
  position: relative;
  top: -15px;
  right: -10px;
}
.submit-button {
  width: 200px;
  height: 50px;
  color: #ffffff !important;
  text-align: center;
  border-radius: 5px;
  border: 4px solid #003333 !important;
  background-color: #003333 !important;
  font: 500 20px DINosaur-a, sans-serif;
  margin-top: 15px;
}

.el-checkbox-group {
  display: flex;
  flex-direction: column;
}
.el-checkbox-group /deep/ .el-checkbox__label {
  color: #003333;
}
.el-checkbox-group /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #003333 !important;
  border-color: #003333 !important;
}
.el-checkbox-group /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #003333 !important;
  border-color: #003333 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/contactAgentDialog.vue